/**
 * COMPONENT: DerogationNotice
 *
 * Avertissement « limite d'âge / dérogation », affiché quand une date de
 * naissance saisie met le participant au-delà de 28 ans à la date de l'événement.
 *
 * Il existait depuis le BPI, écrit à la main dans PublicFormPage. La recette 4L
 * du 22/09 le réclame aussi au bulletin : « dans le cas où une équipe n'a pas
 * de copilote mais qu'il en enregistre un, il faut que l'on ait la popin
 * dérogation, idem au BPI ». D'où l'extraction ici — un seul texte, une seule
 * règle d'âge, deux formulaires. Le jour où l'équipe changera la formulation,
 * elle changera au même endroit pour les deux.
 *
 * Le composant ne décide de rien : il informe. Poser `has_derogation` ou
 * `derogation_pending` sur l'équipage reste un geste du staff.
 */

import { X } from 'lucide-react';

export function DerogationNotice({
  onDismiss,
  className = '',
}: {
  onDismiss: () => void;
  /** Positionnement laissé à l'appelant : flottant au BPI, en flux au BED. */
  className?: string;
}) {
  return (
    <div
      role="status"
      className={`rounded-md border border-orange-200 bg-orange-50 p-3 text-sm text-orange-800 ${className}`}
    >
      <button
        type="button"
        onClick={onDismiss}
        className="absolute right-2 top-2 text-orange-400 hover:text-orange-600"
        aria-label="Fermer"
      >
        <X className="h-4 w-4" />
      </button>
      <p className="mb-2 pr-5 font-semibold">⚠️ Information importante : Limite d'âge</p>
      <p className="mb-2">
        L'aventure du 4L Trophy est{' '}
        <strong>normalement réservée aux participants âgés de 18 à 28 ans</strong>. Puisque vous
        avez plus de 28 ans, <u>votre inscription nécessite une validation particulière</u>. Nous
        vous invitons à contacter notre équipe à l'adresse contact@4ltrophy.com afin de connaître la
        procédure et formuler une demande de dérogation.
      </p>
      <p className="mb-2">
        Votre inscription pourra être validée à titre provisoire après le paiement, mais ne
        deviendra définitive qu'après réception et validation de votre demande de dérogation. En
        l'absence de demande, ou en cas de refus,{' '}
        <strong>votre inscription pourra être annulée</strong>.
      </p>
      <p>
        À très vite,
        <br />
        L'équipe du 4L Trophy
      </p>
    </div>
  );
}
